import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { whitelistStyles } from "../../core/hoc";
import Panel from "../panel";
import Radio from "../../core/checkbox-like/radio";
import Label from "../../core/label";
import ColorSwatch from "../color-swatch";
import { colors } from "../../../enums";
var DISPLAY_COUNT = 10;
var StyleVariationSelect = createComponent({
  displayName: 'StyleVariationSelect',
  propTypes: {
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      color: PropTypes.string
    })).isRequired,
    onChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
    id: PropTypes.string
  },
  defaultProps: {
    id: undefined
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var items = _mapInstanceProperty(_).call(_, props.options, function (option) {
      logger.warn('Prop `options` object must have all properties, `label`, `value`, and `color` defined, in StyleVariationSelect', !option.label || !option.value || !option.color);
      return /*#__PURE__*/React.createElement("div", {
        className: "ck-style-select-item",
        key: option.value
      }, /*#__PURE__*/React.createElement(Radio, {
        value: option.value,
        onChange: props.onChange,
        isSelected: props.selectedValue === option.value,
        id: props.id
      }), /*#__PURE__*/React.createElement(ColorSwatch, {
        value: option.color
      }), /*#__PURE__*/React.createElement(Label, {
        hasPadding: true,
        text: option.label,
        color: props.isInverted ? colors.WHITE : colors.BASE
      }));
    });

    var displayItems = _.take(items, DISPLAY_COUNT);

    var restOfItems = _.takeRight(items, items.length - DISPLAY_COUNT);

    var selectedOption = _findInstanceProperty(_).call(_, props.options, {
      value: props.selectedValue
    });

    var isSelectedHidden = _indexOfInstanceProperty(_).call(_, props.options, selectedOption) >= DISPLAY_COUNT;
    return /*#__PURE__*/React.createElement("div", {
      className: "ck-style-variation-select",
      style: props.style
    }, displayItems, !_.isEmpty(restOfItems) ? /*#__PURE__*/React.createElement(Panel.ExpandableContent, {
      isExpanded: isSelectedHidden,
      expandedTrigger: "Less",
      collapsedTrigger: "More"
    }, restOfItems) : null);
  }
});
export default whitelistStyles()(StyleVariationSelect);
//# sourceMappingURL=index.js.map